/** @format */

import axios from "axios";
import swal from "sweetalert";
import {
  DeleteOutlined,
  SaveOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

const calculateAll = (manbalar) => {
  if (!manbalar || manbalar.length === 0) return [];

  // 1. Dastlab barcha kiritilgan (oddiy) qiymatlarni saqlaymiz
  const values = {};
  manbalar.forEach(item => {
    values[item.id] = parseFloat(item.suvi) || 0;
  });

  // 2. Formulalarni hisoblashda tartib muhim.
  // Avval ichki (kichik) yig'indilar, keyin umumiy jami hisoblanishi kerak.
  // Buning uchun massivni ikki marta aylanamiz yoki formulalarni qayta ishlaymiz.

  let updatedManbalar = [...manbalar];

  // Birinchi o'tish: Barcha formulalarni hisoblab chiqish
  const runCalculation = (items) => {
    return items.map((item) => {
      if (item.formula) {
        let total = 0;
        const formula = item.formula.toString().replace(/\s/g, "").toLowerCase();
        const parts = formula.split(",");

        parts.forEach((part) => {
          if (part.startsWith("sum(") && part.endsWith(")")) {
            const range = part.substring(4, part.length - 1);
            const [start, end] = range.split(":").map(Number);
            if (!isNaN(start) && !isNaN(end)) {
              for (let id = start; id <= end; id++) {
                total += values[id] || 0;
              }
            }
          } else if (!isNaN(Math.abs(part)) && part !== "") {
            const targetId = parseInt(Math.abs(part));
            if (part.startsWith("-")) { // Manfiy bo'lsa ayirish
              total -= values[targetId] || 0;
            } else {
              total += values[targetId] || 0;
            }
          }
        });

        const formattedTotal = parseFloat(total.toFixed(2));
        values[item.id] = formattedTotal; // Keyingi formulalar uchun yangilangan qiymatni saqlaymiz
        return { ...item, suvi: formattedTotal };
      }
      return item;
    });
  };

  // Zanjirsimon formulalar (yig'indining yig'indisi) ishlashi uchun 2 marta aylanamiz
  updatedManbalar = runCalculation(updatedManbalar);
  updatedManbalar = runCalculation(updatedManbalar);

  return updatedManbalar;
};

function Add({ vaqt, date, setDate, havza }) {
  const [manbalar, setManbalar] = useState([]);
  const [ldate, setLdate] = useState(date);
  const [changed, setChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  const keyDown = (e) => {
    if (e.key === "Enter") {
      const fields = Array.from(document.querySelectorAll("input[type='number']:not([readonly])"));
      const index = fields.indexOf(e.target);
      if (fields[index + 1]) fields[index + 1].focus();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/itb/manbalar?date=${ldate}&vaqt=${vaqt}`,
            header()
        );
        // API dan 'manbalar' massivi keladi
        if (res.data && res.data.manbalar) {
          setManbalar(calculateAll(res.data.manbalar));
        }
      } catch (e) {
        swal("Xato", "Ma'lumot yuklashda xatolik!", "error");
      } finally {
        setLoading(false);
      }
    };
    if (ldate && vaqt) fetchData();
  }, [ldate, vaqt]);

  const setHange = (v, id) => {
    const updated = manbalar.map(item =>
        item.id === id ? { ...item, suvi: v } : item
    );
    setManbalar(calculateAll(updated));
    setChanged(true);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const dataPayload = {};
      manbalar.forEach(item => {
        dataPayload[item.id] = item.suvi ? item.suvi.toString() : "0";
      });

      const payload = {
        date: ldate,
        vaqt: vaqt,
        data: dataPayload
      };

      await axios.post(
          `${getEnv('REACT_APP_BASE_URL')}/v1/itb/manbalar/upsert`,
          payload,
          header()
      );

      swal("Muvaffaqiyat", "Ma'lumotlar saqlandi!", "success");
      setChanged(false);
    } catch (e) {
      swal("Xato", "Saqlashda xatolik!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className='table-box' style={{ padding: '20px' }}>
        <div className='table-content-top' style={{ marginBottom: '15px' }}>
          <div className='table-top-left'>
            <NavLink to='/asosiymanbalar' className='btn btn-sm btn-outline-danger'><ArrowLeftOutlined /> Chiqish</NavLink>
            {changed && (
                <button className='btn btn-sm btn-primary ms-3' onClick={handleSave}>
                  Saqlash <SaveOutlined />
                </button>
            )}
          </div>
          <div className='table-top-right'>
            <input type='date' className='form-control form-control-sm' value={ldate} onChange={(e) => setLdate(e.target.value)} />
          </div>
        </div>

        <div id='content'>
          {loading ? <LoadingCard loading={loading} heightSize='50vh' /> : (
              <table className='table table-bordered table-style' style={{ width: "100%", maxWidth: "900px", margin: "0 auto" }}>
                <thead className="bg-light text-center">
                <tr>
                  <th colSpan={4} className="py-3">
                    {ldate} dagi "{vaqt === "ortacha" ? "kunlik o'rtacha" : "ertalabki"}" ma'lumotlar
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "50px" }}>T/R</th>
                  <th>ITB nomi va asosiy nuqtalar</th>
                  <th style={{ width: "100px" }}>Birlik</th>
                  <th style={{ width: "150px" }}>Suv miqdori</th>
                </tr>
                </thead>
                <tbody>
                {manbalar.map((item, index) => (
                    <React.Fragment key={item.id}>
                      {/* Agar title mavjud bo'lsa, tuman nomini chiqarish */}
                      {item.title && (
                          <tr className="bg-light">
                            <th colSpan={4} className="text-center fw-bold text-danger py-2">{item.title}</th>
                          </tr>
                      )}
                      <tr>
                        <td className="text-center">{item.tartibi || index + 1}</td>
                        <td className="text-start ps-3" style={{ fontWeight: item.formula ? 'bold' : 'normal' }}>
                          {item.manba_nomi}
                        </td>
                        <td className="text-center">{item.birligi}</td>
                        <td className="p-0">
                          <input
                              type='number'
                              className="text-center w-100"
                              value={item.suvi ?? ""}
                              onChange={(e) => setHange(e.target.value, item.id)}
                              readOnly={!!item.formula}
                              onKeyDown={keyDown}
                              style={{
                                border: 'none',
                                padding: '8px',
                                backgroundColor: item.formula ? '#f1f3f5' : 'white',
                                fontWeight: item.formula ? 'bold' : 'normal'
                              }}
                          />
                        </td>
                      </tr>
                    </React.Fragment>
                ))}
                </tbody>
              </table>
          )}
        </div>
      </div>
  );
}

export default Add;